export default {
    path : "factory-item-allsuccess",
    name : "factory-item-allsuccess",
    meta : {
        title : "关注项目"
    },
    component: () => import('@/pages/factory/allsuccess/Index'),
    redirect: {
        name : "factory-item-allsuccess-whole"
    },
    children: [
        {
            path: 'all',
            name: 'factory-item-allsuccess-whole',
            meta: {
                title: '厂房项目-列表页'
            },
            component: () => import('@/pages/itemCommon/List'),
        },
        {
            path: 'recent',
            name: 'factory-item-allsuccess-recent',
            meta: {
                title: '厂房项目-列表页'
            },
            component: () => import('@/pages/itemCommon/List'),
        },
        {
            path: 'atme',
            name: 'factory-item-allsuccess-atme',
            meta: {
                title: '厂房项目-列表页'
            },
            component: () => import('@/pages/itemCommon/List'),
        },
        {
            path: 'meat',
            name: 'factory-item-allsuccess-meat',
            meta: {
                title: '厂房项目-列表页'
            },
            component: () => import('@/pages/itemCommon/List'),
        },
        {
            path: 'reply',
            name: 'factory-item-allsuccess-reply',
            meta: {
                title: '厂房项目-列表页'
            },
            component: () => import('@/pages/itemCommon/List'),
        },
        {
            path: 'search',
            name: 'factory-item-allsuccess-search',
            meta: {
                title: '厂房项目-列表页'
            },
            component: () => import('@/pages/itemCommon/List'),
        },
    ]
}


// WEBPACK FOOTER //
// ./src/router/factory/allsuccessitem/index.js